import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import dayjs from 'dayjs';
import { ReactComponent as AccessGrantedIcon } from 'assets/icons/access-granted.svg';
import { ReactComponent as AccessDeniedIcon } from 'assets/icons/access-denied.svg';
import type { ILiveActivity } from 'features/eiq-secure/stores/live-activity/live-activity.types';
import './live-activity-feed.scss';

type Props = {
  logs: ILiveActivity[];
  filter?: ReactNode;
};

const getColorClass = (log: ILiveActivity) => {
  if (log.owner === 'Unknown') {
    return 'grey';
  }
  if (log.accessStatus === 'Credential') {
    return 'green';
  }
  if (log.accessStatus === 'CredentialDenied') {
    return 'orange';
  }
  return 'red';
};

const renderLog = (log: ILiveActivity) => {
  const vehicleInfo = [
    log.color && log.year ? log.color : '',
    log.make,
    log.licensePlate && log.licenseState ? `- ${log.licenseState} ${log.licensePlate}` : '',
  ]
    .filter(Boolean)
    .join(' ');

  let ownerInfo = `${log.owner}${log.deviceId ? ` (${log.deviceId})` : ''}`;
  if (log.accessStatus === 'Credential') {
    ownerInfo += ' Access Granted';
  }
  if (log.accessStatus === 'CredentialDenied') {
    ownerInfo += ' Access Denied';
  }

  const timeAndChannel = `${dayjs(log.timestamp).format('MMM D, YYYY h:mm:ssa')} (${log.note})`;

  const isGranted = log.accessStatus === 'Credential';

  const className = getColorClass(log);
  const Icon = isGranted ? AccessGrantedIcon : AccessDeniedIcon;

  return (
    <div className={`message ${className}`}>
      <div className="icon">
        <Icon />
      </div>
      <div>
        <div>{ownerInfo}</div>
        {vehicleInfo && <div>{vehicleInfo}</div>}
        <div>{timeAndChannel}</div>
      </div>
    </div>
  );
};

export const LiveActivityFeed = observer(({ logs, filter }: Props) => (
  <div className="eiq-live-activity">
    <div className="title">LIVE ACTIVITY</div>
    {filter}
    <div className="body">
      {logs.map((item, index) => (
        <div key={`activity-log-${index}`} style={index === 0 ? { fontWeight: 600 } : undefined}>
          {renderLog(item)}
        </div>
      ))}
    </div>
  </div>
));
